
import Vue from 'vue';
import { Watch } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import axios from 'axios';
import Component from 'vue-class-component';
import { User } from './store/models/ProfileModel';
import AuthService from './services/auth-service';
import { ConfirmationDialogInfo, Snackbar } from './store/models/CustomerModel';
import confirmationDialog from '@/components/ConfirmationDialog.vue';
import { GetNewOrderPo } from './helpers/OrderlineHelper';
const namespace: string = 'profile';

Component.registerHooks(['beforeRouteUpdate', 'beforeRouteLeave']);
@Component({
  components: {
    confirmationDialog
  }
})
export default class extends Vue {
  $refs!: {
    confirmationLeaveDialog: HTMLFormElement;
    ConfirmationDialog: HTMLFormElement;
  };
  @Getter('isAuthenticated', { namespace }) isAuthenticated!: boolean;
  @Getter('getCurrentSnackbar', { namespace: 'customer' })
  getSnackbarInfo!: Snackbar;
  @Getter('impersonatedUser', { namespace: 'profile' })
  impersonatedUser!: string;
  @Getter('getCurrentConfirmationDialog', { namespace: 'profile' })
  getCurrentConfirmationDialog!: ConfirmationDialogInfo;
  @Action('GetItemInfo', { namespace: 'items' })
  getItemInfo: any;
  @Action('logout', { namespace }) logout: any;
  @Action('getDieTemplates', { namespace: 'dies' })
  getDieTemplates: any;
  @Action('getCurrentCustomer', { namespace: 'customer' })
  getCurrentCustomerStore: any;
  @Action('GetShoppingCart', { namespace: 'orderlines' })
  getShoppingCart: any;
  @Action('getUserValidation', { namespace }) getUserValidation: any;
  layout = 'div';

  snackbarTimeout: number = -1;
  snackbarText: string = '';
  snackbar: boolean = false;
  actionText: string = 'close';
  action: any = null;
  footerOptions: any = [
    { Id: 2, Text: 'Contact us', Readonly: false },
    { Id: 4, Text: 'Terms of Service', Readonly: false },
    {
      Id: 5,
      Text: `@ ${new Date().getFullYear()} Just One Label, LLC`,
      Readonly: true
    }
  ];

  @Watch('isAuthenticated')
  onIsAuthenticatedChange(val: boolean, prev: boolean) {
    if (val) {
      this.getDefaults();
    }
  }
  @Watch('getCurrentConfirmationDialog', { deep: true })
  onConfirmationDialogChange(val: ConfirmationDialogInfo) {
    this.$refs.ConfirmationDialog.openDialog(val);
  }

  @Watch('getSnackbarInfo')
  onChange() {
    let snackbarData = this.getSnackbarInfo;
    this.snackbarTimeout = snackbarData.timeout;
    this.snackbarText = snackbarData.message;
    this.actionText = snackbarData.actionText;
    this.action = snackbarData.customAction;
    this.snackbar = true;
  }
  handleFooterActions(option: string) {
    switch (option) {
      case 'Contact us':
        return this.$router.push({ name: 'Contact' });
      case 'Terms of Service':
        return this.$router.push({ name: 'Terms' });
    }
  }
  handleConfirmationDialogResponse(didAccept: boolean) {
    if (didAccept) this.getCurrentConfirmationDialog.action();
  }
  onSnackbarActionClick() {
    if (this.action !== null) this.action();
    this.snackbar = false;
  }
  setUpUserCredentials() {
    const localStorageUser = localStorage.getItem('user');
    if (localStorageUser) {
      this.getItemInfo();
      this.getDieTemplates();
      const user = new User(JSON.parse(localStorageUser));
      if (user.isImpersonating) {
        this.$store.dispatch('profile/getImpersonatedCustomer');
      } else {
        this.$store.commit('profile/setToken', user);
      }
      this.getCurrentCustomerStore();
    }
  }
  setUpAxiosGlobals() {
    let that = this;
    axios.interceptors.response.use(
      function(response) {
        return response;
      },
      function(error) {
        // Do something with response error
        if (error.response && error.response.status === 401) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          that.logout();
        }
        return Promise.reject(error);
      }
    );
  }
  setIdleTimer() {
    let time: any;
    window.onload = resetTimer;
    // DOM Events
    document.onmousemove = resetTimer;
    document.onkeypress = resetTimer;

    const refreshPage = () => {
      window.location.reload(true);
    };

    function resetTimer() {
      clearTimeout(time);
      // time = setTimeout(refreshPage, 3000);
      time = setTimeout(refreshPage, 30 * 60000);
    }
  }
  checkFormatVersion() {
    const formatVersion = localStorage.getItem('formatVersion');
    if (!formatVersion) {
      this.logout();
    }
  }
  getDefaults() {
    this.getShoppingCart();
    this.getUserValidation();
    this.getDieTemplates();
  }
  async created() {
    await this.setUpAxiosGlobals();
    this.setUpUserCredentials();
    this.setIdleTimer();
  }
  async mounted() {
    if (this.isAuthenticated) {
      this.getShoppingCart();
    }
  }
}
